module.exports = __webpack_public_path__ + "img/target3.22963fb2.png";